import { proxy } from 'valtio';

export const defaultHideCursorState = false;

export const currentCursorVisibilityState: { hideCursors: boolean } = proxy({
  hideCursors: defaultHideCursorState,
});
